import PricingContainer from "../../../../Components/Applications/Ecommerce/Pricing/PricingContainer";

const Pricing = () => {
  return <PricingContainer />;
};

export default Pricing;
